import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// All enrollment portal endpoints are namespaced under /api/enroll on the merged SAA backend
export const API = `${BACKEND_URL}/api/enroll`;

export const api = axios.create({ baseURL: API });

export async function fetchEnrollment(email) {
  const { data } = await api.get(`/enrollment/${encodeURIComponent(email)}`);
  return data;
}

export async function saveEnrollment({ email, current_step, data, comp_family }) {
  const body = { email, current_step, data };
  if (comp_family) body.comp_family = comp_family;
  const res = await api.put(`/enrollment`, body);
  return res.data;
}

export async function submitEnrollment(email) {
  const { data } = await api.post(`/enrollment/submit`, { email });
  return data;
}

export async function createCheckout({ email, enrollment_id, plan = "full" }) {
  const { data } = await api.post(`/payments/checkout`, {
    email,
    package_id: "enrollment_fee",
    plan,
    origin_url: window.location.origin,
    enrollment_id,
  });
  return data;
}

export async function fetchPaymentsConfig() {
  const { data } = await api.get(`/payments/config`);
  return data;
}

export async function getPaymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
}

export async function syncPayment(sessionId) {
  const { data } = await api.post(`/payments/sync/${sessionId}`);
  return data;
}

export function downloadPdfUrl(email) {
  return `${API}/enrollment/${encodeURIComponent(email)}/pdf`;
}
